export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-mountains-7add3fdeecbbac83f5b69e5ea92cae0a.svg";